module.exports = "<p>\n  office works!\n</p>\n"